import { initInfiniteHorizontalMarquee } from '../functions/infiniteHorizontalMarquee';

const rootSelector = '.js-logo-slider',
    trackSelector = '.js-logo-slider-wrapper',
    slideSelector = '.js-logo-slider-slide';

const AUTO_SCROLL_PX_S = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 0
    : 44;

function getSpvAndGap(containerWidth) {
    if (containerWidth >= 1024) {
        return { spv: 7, gap: 24 };
    }
    return { spv: 2.5, gap: 12 };
}

function initLogoSliderMarquee() {
    if (!document.querySelector(rootSelector)) {
        return;
    }

    initInfiniteHorizontalMarquee({
        containerSelector: rootSelector,
        trackSelector,
        slideSelector,
        getSpvAndGap,
        speedPxPerSecond: AUTO_SCROLL_PX_S,
        remeasureOnImageLoad: true,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoSliderMarquee);
} else {
    initLogoSliderMarquee();
}
